import React from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { ReservationStatus } from "@/types/reservation";
import { NonEditableFormField } from "../../guests/components/form/FormFields";
import { formatStatusLabel } from "@/components/pages/reservations/utils/formatStatusLabel";
import { useTranslation } from "react-i18next";

const ReservationStatusSelect = ({
  value,
  onChange,
  isEdit = true,
}: {
  isEdit?: boolean;
  value: ReservationStatus;
  onChange: (value: string) => void;
}) => {
  const { t } = useTranslation();

  if (!isEdit) {
    return (
      <NonEditableFormField
        value={formatStatusLabel(value)}
        isCopy={false}
        label={t("reservation.form.reservationStatus")}
        labelClassName="text-foreground"
        contentClassName="h-9 mt-3 px-3 py-1 items-center border border-neutral-200 rounded-lg text-muted-foreground text-sm"
        containerClassName="flex-1"
      />
    );
  }

  return (
    <div className="flex-1">
      <label className="block text-sm font-medium text-foreground">
        {t("reservation.form.reservationStatus")}
      </label>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger
          showIcon={false}
          className="w-full h-9 mt-3 px-3 py-1 justify-start items-center border border-neutral-200 rounded-lg text-muted-foreground text-sm focus:border-neutral-200 hover:border-neutral-200 data-[size=default]:h-9 cursor-pointer"
        >
          <SelectValue
            placeholder={t("reservation.placeholders.chooseStatus")}
          />
        </SelectTrigger>
        <SelectContent>
          {Object.values(ReservationStatus).map((statusValue) => (
            <SelectItem key={statusValue} value={statusValue}>
              <span className="text-muted-foreground">
                {formatStatusLabel(statusValue)}
              </span>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default ReservationStatusSelect;
